import { useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "@/store";
import { fetchProjects } from "@/store/projectsSlice";
import { fetchFeatureFlags } from "@/store/featureFlagsSlice";
import { fetchStats } from "@/store/requestsSlice";
import {
  DashboardTimeRange,
  getDashboardStartDate,
} from "@/constants/dashboard";

export function useDashboardPage() {
  const dispatch = useAppDispatch();
  const { items: projects } = useAppSelector((s) => s.projects);
  const { items: flags } = useAppSelector((s) => s.featureFlags);
  const { stats, loading } = useAppSelector((s) => s.requests);

  const [timeRange, setTimeRange] = useState<DashboardTimeRange>(
    DashboardTimeRange.D7,
  );
  const [selectedProject, setSelectedProject] = useState("");

  useEffect(() => {
    dispatch(fetchProjects());
    dispatch(fetchFeatureFlags());
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      fetchStats({
        projectId: selectedProject || undefined,
        startDate: getDashboardStartDate(timeRange),
      }),
    );
  }, [dispatch, selectedProject, timeRange]);

  const activeFlagCount = useMemo(
    () => flags.filter((f) => f.enabled).length,
    [flags],
  );

  return {
    projects,
    flags,
    stats,
    loading,
    timeRange,
    setTimeRange,
    selectedProject,
    setSelectedProject,
    activeFlagCount,
  };
}
